<template>
    <BaseAlertMaintenance v-if="getErrorStatus(error) === 503" />
    <BaseAlertUnconfirmedPassword v-else-if="getErrorStatus(error) === 423" />
    <BaseAlertNotFound v-else-if="getErrorStatus(error) === 404" />
    <BaseAlertErrorServer v-else-if="getErrorStatus(error) === 500" />
</template>

<script setup lang="ts">
import { AxiosError } from 'axios';
import BaseAlertErrorServer from './BaseAlertErrorServer.vue';
import BaseAlertMaintenance from './BaseAlertMaintenance.vue';
import BaseAlertNotFound from './BaseAlertNotFound.vue';
import BaseAlertUnconfirmedPassword from './BaseAlertUnconfirmedPassword.vue';
import { getErrorStatus } from '@/utils/errorUtils';

defineProps<{
    error: Error | AxiosError | null;
}>();
</script>
